var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9727 5.15205C15.8825 -1.71861 6.41046 -1.71609 0.322645 5.15205C0.0937071 5.41032 0.0892383 5.84763 0.310613 6.11554L1.48761 7.53982C1.69868 7.79558 2.0383 7.80103 2.25761 7.55575C7.27362 1.95089 15.0211 1.94963 20.0381 7.55575C20.2574 7.80103 20.597 7.79516 20.8081 7.53982L21.9851 6.11554C22.2061 5.84763 22.2017 5.41032 21.9727 5.15205ZM11.1477 13.4168C9.93252 13.4168 8.94768 14.618 8.94768 16.1002C8.94768 17.5823 9.93252 18.7835 11.1477 18.7835C12.3628 18.7835 13.3477 17.5823 13.3477 16.1002C13.3477 14.618 12.3628 13.4168 11.1477 13.4168ZM18.1145 9.91208C14.1524 5.63841 8.13849 5.64302 4.1809 9.91208C3.94371 10.1678 3.93615 10.6118 4.1613 10.8827L5.34518 12.3078C5.55143 12.556 5.88349 12.5728 6.10315 12.3414C8.98893 9.29868 13.313 9.30538 16.1919 12.3414C16.4115 12.5728 16.7436 12.5564 16.9498 12.3078L18.1337 10.8827C18.3592 10.6118 18.3513 10.1674 18.1145 9.91208Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.003b4e29cab6453c0dec2199f07dc6f4.svg";
export { ForwardRef as ReactComponent };